import { from, of, switchMap, timer } from "rxjs"

import type {
  EquityQuoteRequest,
  HistoricalBarRequest,
  IMarketDataService,
  LatestBarRequest,
} from "../MarketDataService"
import { SUCCESS_MARKET_STATUS_RESULT } from "../MarketDataService"
import {
  createMockHistoricalBarData,
  createMockLatestBarData,
  createMockQuote,
} from "../mockData/marketData"

export const MarketDataService: IMarketDataService = {
  getLatestQuote: (input: EquityQuoteRequest) =>
    timer(300, 1_000).pipe(
      switchMap(() =>
        from(
          input.symbols
            .split(",")
            .map((s) => createMockQuote({ ...input, symbols: s.trim() })),
        ),
      ),
    ),
  getHistoricalBars: (input: HistoricalBarRequest) =>
    from(createMockHistoricalBarData(input)),
  getLatestBars: (input: LatestBarRequest) =>
    timer(300, 1_000).pipe(
      switchMap(() =>
        from(
          input.symbols
            .split(",")
            .map((s) =>
              createMockLatestBarData({ ...input, symbols: s.trim() }),
            ),
        ),
      ),
    ),
  subscribeToMarketStatus: () =>
    of({ type: SUCCESS_MARKET_STATUS_RESULT, payload: { isMarketOpen: true } }),
}
